module.exports = __webpack_public_path__ + "img/excel.c5e1538a.svg";